<template>
<div class="content-i">
    <div class="content-box">

        <!--START - Recent Ticket Comments-->
        <div class="element-wrapper">
            <h6 class="element-header">Exported Reports</h6>
            <div class="element-box-tp">
                <EmptyState v-if="!pagination.data" >
                    <div slot="empty_state_text">
                       There are no exported reports
                    </div>
                </EmptyState>
                <Loader v-if="isLoading == false" />
                <div class="table-responsive" v-else>
                    <table class="table table-padded">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Request ID</th>
                                <th>Requested By</th>
                                <th>Report Details</th>
                                <th>Export Date</th>
                                <th>Rows</th>
                                <th>Export Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="report in pagination.data">
                                <td class="text-center"><input class="form-control" type="checkbox"></td>
                                <td>RPT{{report.id_worklist_export}}</td>
                                <td>
                                    <div class="user-with-avatar"><img alt="" :src="report.avatar"><span>{{report.name}}</span></div>
                                </td>
                                <td>
                                    <div class="capitalize">{{report.type .replace(/_/g, ' ')}}</div>
                                </td>
                                <td><span>{{report.created_at}}</span></td>
                                <td ><a>{{report.rows}}</a></td>
                                <td class="nowrap"> <div v-html="formatReportStatus(report)"></div></td>
                                <td class="row-actions">
                                    <a v-if="report.path != null" :href="report.path"><i class="fas fa-download"></i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <Pagination v-if="pagination.last_page > 1 " :pagination="pagination" @paginate="getExportedReports()" :offset="5"></Pagination>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import EmptyState from '@/components/common/EmptyState'
import Loader from '@/components/common/Loader'

export default {
  components: {
    Pagination,
    EmptyState,
    Loader
  },
  data: function () {
    return {
      isLoading: true,
      pagination: {
        'current_page': 1
      }
    }
  },
  mounted: function () {
    var self = this
    this.getExportedReports()

    var channel = this.$pusher.subscribe('export')
    console.log(channel)
    channel.bind('complete', function (data) {
      self.getExportedReports()
    })
  },
  methods: {
    getExportedReports: function () {
      var self = this
      const url = '/reportdesk/report/exported?page=' + this.pagination.current_page
      self.isLoading = true
      this.$http.get(url, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          console.log(response)
          self.pagination = response.data.reports
          self.isLoading = true
        })
        .catch(function (error) {
          console.log(error)
          self.isLoading = true
        })
    },
    formatReportStatus: function (report) {
      var response = ''
      if (report.path == null) {
        response = '<div class="loader12"></div>'
      } else {
        response = '<span class="status-pill smaller green"></span><span>Available</span>'
      }

      return response
    }
  }
}
</script>
